import { ScreenActions } from '../constants/Screen';

export function setSmallScreenUI(isScreenSmall) {
  return {
    type: ScreenActions.SET_SMALL_SCREEN_UI,
    data: isScreenSmall,
  };
}

export function setCurrentScreenDimensions(screenWidth, screenHeight) {
  return {
    type: ScreenActions.SET_CURRENT_SCREEN_DIMENSIONS,
    data: {
      screenWidth,
      screenHeight,
    },
  };
}
